import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-height: 112px;
  flex: 1;
  gap: 20px;
  font-size: 60px;
  color: blue;
  box-sizing: border-box;
  overflow: hidden;
  flex-wrap: wrap;
  @media (max-width: 550px) {
    max-height: 244px;
  }
`;
